export const GAP = 10;

export const TABLE_FONT_SIZE = 8;

export const PAGE_COLOR = '#004F6B';

export const PAGE_CHILD_COLOR = '#9CA3AF';

export const MAX_COLUMNS_PER_CATEGORY = {
  ledgers: 15,
  invoice: 15
};

// custom style for columns of table based on category name
export const CATEGORY_TABLE_COLUMNS_STYLE = {
  terminalData: { PIN: { cellWidth: 60 } }
};

export const PORTRAIT_MAX_COLUMNS = 10;
export const LANDSCAPE_MAX_COLUMNS = 15;
export const CELL_LENGTH_MULTIPLE = 2.5;
